import React from 'react';
import { Close } from 'lib/@mui/Icons';

import { useEmailVerificationBanner } from 'hooks/useEmailVerificationBanner';
import {
    EZLOGIC_TEXT_EMAIL_VERIFICATION_BANNER,
    EZLOGIC_TITLE_LET_IS_VERIFY_YOUR_EMAIL,
} from 'constants/language_tokens';
import { useTranslate } from 'features/languages';

import style from './style.module.scss';

export const EmailVerificationBanner = () => {
    const { t } = useTranslate();
    const { shouldShowBanner, closeBanner } = useEmailVerificationBanner();

    if (!shouldShowBanner) {
        return;
    }

    return (
        <div className={style.box}>
            <div className={style.content}>
                <div className={style.title}>{t(EZLOGIC_TITLE_LET_IS_VERIFY_YOUR_EMAIL)}</div>
                <p className={style.text}>{t(EZLOGIC_TEXT_EMAIL_VERIFICATION_BANNER)}</p>
            </div>

            <Close className={style.closeIcon} onClick={closeBanner} />
        </div>
    );
};
